import {Component, Input, OnInit} from '@angular/core';
import {ModalController} from "@ionic/angular";
import {AppStateService} from "../../providers/app-state.service";
import {CommonUtils} from "../../utils/common";
import {AbstractControl, FormBuilder, FormGroup, Validators} from "@angular/forms";
import {RefundDto} from "../../models/refund-dto.model";
import {RefundRequestsService} from "../../providers/refund-requests.service";

@Component({
  selector: 'app-accept-refund',
  templateUrl: './accept-refund.component.html',
  styleUrls: ['./accept-refund.component.scss'],
})
export class AcceptRefundComponent implements OnInit {

  @Input() refundUUID: string;
  @Input() vetReservationUUID: string;
  @Input() reservationCancellationExpirationDate: Date;
  @Input() requestReceivedDate: Date;
  @Input() orderValue: number;
  @Input() price: number;
  type: 'REG' | 'CLINIC' | 'SPECIAL' | 'FULL' = 'SPECIAL';
  @Input() reason: string;
  refundDto: RefundDto;
  acceptFormGroup: FormGroup;
  @Input() percentageValues: Map<string, number>;

  isBusy: boolean;
  refundValue: number;
  percent: number;
  regex = new RegExp('^\\d+(\\.\\d{1,2})?$');
  decimalPlacesRegex = new RegExp('^\\d+(\\.\\d{2})');
  private alertPresented: boolean = false;



  constructor(private modalController: ModalController,
              private appStateService: AppStateService,
              public commonUtils: CommonUtils,
              private formBuilder: FormBuilder,
              private refundRequestsService: RefundRequestsService) {
  }

  ngOnInit() {
    this.appStateService.isBusySubject.subscribe(e => {
      this.isBusy = e;
    });
    this.onChangeValue('SPECIAL');
    this.acceptFormGroup = this.formBuilder.group({
      reason: [this.reason, Validators.required],
      type: [this.type, Validators.required],
      price: [this.price, [Validators.required, this.priceValidator.bind(this)]],
    });
    this.acceptFormGroup.get('price')?.markAsTouched();
    this.acceptFormGroup.get('type')?.valueChanges.subscribe(() => {
      this.acceptFormGroup.get('price')?.updateValueAndValidity();
    });
  }
  priceValidator(control: AbstractControl) {
    const value = control.value;
    const isValid = (value < this.orderValue) && (value >= 0) && this.regex.test(value);
    return isValid ? null : {price: true};
  }

  onAction() {
    if(this.acceptFormGroup.controls.type.value === 'FULL') {
      this.acceptFormGroup.controls.type.setValue('SPECIAL');
    }
    this.refundDto = this.commonUtils.formGroupValuesToObject<RefundDto>(new RefundDto(), this.acceptFormGroup);
    this.refundDto.uuid = this.refundUUID;
    this.modalController.dismiss(this.refundDto).then(() => {
    });
  }

  onCancelAction() {
    if (!this.isBusy) {
      console.log(this.acceptFormGroup);
      this.modalController.dismiss(null).then(() => {
      });
    }
  }

  onChangeValue(type) {
    this.type = type;
    this.refundValue = (this.percentageValues.get(type) / 100)* this.orderValue;
    if(this.type === 'REG'){
      this.percent = this.percentageValues.get('REG');
      this.price = this.orderValue - this.refundValue;
    } else {
      this.percent = 100;
      this.refundValue = this.orderValue;
      this.price = 0;
    }

  }


  changeTest($event: any) {
    let eventString: string = $event.detail.value.replace(/,/g,'.');
    eventString = eventString.replace(/^0\d+/g,'0');
    eventString = eventString.replace(/^\./g,'');
    eventString = eventString.replace(/\.\d*\./g,'.');
    eventString = eventString.replace('-','');
    eventString = eventString.replace(/[^\d.]/g,'');
    this.acceptFormGroup.get('price').setValue(eventString);
    if(eventString.match(this.decimalPlacesRegex)) {
      this.acceptFormGroup.get('price').setValue(eventString.match(this.decimalPlacesRegex)[0]);
    }

    let pr = this.acceptFormGroup.get('price').value;
    if(!isNaN(pr)){
      if(pr >= this.orderValue){
        this.handleAlert('Kwota do potrącenia nie może przekraczać wartości zamówienia');
        this.refundValue = 0;
        this.percent = 0;
      } else if (pr < 0) {
        this.handleAlert('Kwota do potrącenia nie może przyjmować wartości ujemnych');
        this.refundValue = 0;
        this.percent = 0;
      } else {
        this.price = pr;
        this.refundValue = Math.round((this.orderValue - this.price) * 100) / 100;
        this.percent = Math.round((this.refundValue / this.orderValue) *  100 * 100) / 100;
      }
    } else {
      this.handleAlert('Podaj tylko wartość liczbową');
    }
  }
  handleAlert(alertString: string) {
    if(!this.alertPresented) {
      this.commonUtils.presentAlertToast(alertString);
      this.alertPresented = true;
      setTimeout(() => {
        this.alertPresented = false;
      }, 4000);
    }
  }
}
